angular.module('jv.Admin.Users.Agency.Service',[
        'jv.Admin.Users.URLs.Factory',
        'jv.Admin.Users.Ajax.Factory',
        'jv.Admin.Users.PostParams.Factory',
        'jv.Admin.Users.EmployeeSelect.Factory',
        'jv.Admin.Users.AddToReqConfig.Factory'
    ])
    .service('agencyUserSVC', function(prepareAjaxCall, jvAdminUsersUrls, postParamsFAC, employeeSelectFAC){
        this.employeeSelect = employeeSelectFAC;
        this.getAgencyUserDetails = function (agencyEId, readMode, callback, fail) {
            var options = {
                'ajaxtype': 'getAgencyUserDetailsById',
                'url': postParamsFAC.formatURL(jvAdminUsersUrls.agencyUserDetailsById, agencyEId),
            };
            if(readMode){
                options.url += '?readMode=0';
            }
            prepareAjaxCall({}, options, callback, fail);
        };

        this.getReqsList = function(params, callback, fail) {
            var options = {
                'ajaxtype': 'requisitionListofEmployee',
                'url': jvAdminUsersUrls.requisitionListofEmployee  + params,
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.quickView= function(reqEId, callback, fail) {
            var options = {
                'ajaxtype': 'getRequisitionQuickView',
                'url': postParamsFAC.formatURL(jvAdminUsersUrls.requisitionQuickView, reqEId),
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.getCandidateAnalytics = function(agencyEId, readMode, callback, fail) {
            var options = {
                'ajaxtype': 'getAgencyCandidateAnalyticsById',
                'url': postParamsFAC.formatURL(jvAdminUsersUrls.agencyCandidateAnalyticsById, agencyEId),
            };
            if(readMode){
                options.url += '?readMode=0';
            }
            prepareAjaxCall({}, options, callback, fail);
        };

        this.getRequisitionAnalytics = function(agencyEId, readMode, callback, fail) {
            var options = {
                'ajaxtype': 'getAgencyRequisitionAnalyticsById',
                'url': postParamsFAC.formatURL(jvAdminUsersUrls.agencyRequisitionAnalyticsById, agencyEId),
            };
            if(readMode){
                options.url += '?readMode=0';
            }
            prepareAjaxCall({}, options, callback, fail);
        };

        this.getAgencyUserPagination = function (pageNo, callback, fail) {
            var options = {
                'ajaxtype': 'agencyListPagination',
                'url': jvAdminUsersUrls.agencyListPagination + "&page=" + pageNo,
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.getAgencyListDetails = function(callback, fail){
            var options = {
                'ajaxtype': 'getAgencyListDetails',
                'url': jvAdminUsersUrls.getAgencyListDetails
            };
            function transformRequest(response) {
                if(response && response.agencySearchInfo && response.agencySearchInfo.inviteStatus) {
                    response.agencySearchInfo.inviteStatus = postParamsFAC.transformInvite(response.agencySearchInfo.inviteStatus);
                }
                callback(response);
            }
            prepareAjaxCall({}, options, transformRequest, fail);
        };

        this.getAgencyList = function(params, callback, readMode, fail){
            /*TODO: remove this when BE starts supporting sortBy=Relevance*/
            if(params && params.sortBy === 'Relevance') {
                delete params.sortBy;
            }
            var args = postParamsFAC.serializeObject(params);
            var options = {
                'ajaxtype': 'getAgencyList',
                'url': jvAdminUsersUrls.getAgencyList + $.param(args),
            };
            if(readMode){
                options.url += '&readMode=0';
            }
            prepareAjaxCall({}, options, callback, fail);
        };

        this.sendInvite = function(data, callback, fail){
            var args = postParamsFAC.serializeObject(data);
            var options = {
                'ajaxtype': 'sendAgencyInvite',
                'url': jvAdminUsersUrls.sendAgencyInvite,
                'requestType': 'POST',
                'headerType': 'form'
            };
            prepareAjaxCall(args, options, callback, fail);
        };
        
         this.saveNote = function(data, callback, fail){
            var args = postParamsFAC.serializeObject(data);
            var options = {
                'ajaxtype': 'saveAgencyNote',
                'url': jvAdminUsersUrls.sendAgencyNote,
                'requestType': 'POST',
                'headerType': 'form'
            };
            prepareAjaxCall(args, options, callback, fail);
        };

        this.removeUser = function(data, callback, fail){
            var args = postParamsFAC.serializeObject(data);
            var options = {
                'ajaxtype': 'removeAgencyUser',
                'url': jvAdminUsersUrls.removeAgencyUser,
                'requestType': 'POST',
                'headerType': 'form'
            };
            prepareAjaxCall(args, options, callback, fail);
        };

        this.getInviteTemplates = function(callback, fail){
            var options = {
                'ajaxtype': 'getAgencyInviteTemplates',
                'url': jvAdminUsersUrls.getAgencyInviteTemplates,
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.getRemoveTemplates = function(callback, fail){
            var options = {
                'ajaxtype': 'getAgencyRemoveTemplates',
                'url': jvAdminUsersUrls.getAgencyRemoveTemplates,
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.getAgencyUserFieldInfo = function (callback, fail) {
            var options = {
                'ajaxtype': 'agencyAddNewFormData',
                'url': jvAdminUsersUrls.agencyAddNewFormData,
            };
            prepareAjaxCall({}, options, callback, fail);
        };

        this.saveAgencyUser = function(data, userEId, callback, fail){
            var args = postParamsFAC.serializeObject(data);
            var options = {};

            if(userEId){
                options = {
                    'ajaxtype': 'agencyUpdateByEId',
                    'url': postParamsFAC.formatURL(jvAdminUsersUrls.agencyEditByEId, userEId),
                    'requestType': 'POST',
                    'headerType': 'form'
                };
            } else {
                options = {
                    'ajaxtype': 'agencyAddNew',
                    'url': jvAdminUsersUrls.agencyAddNew,
                    'requestType': 'POST',
                    'headerType': 'form'
                };
            }
            prepareAjaxCall(args, options, callback, fail);
        };

        this.getRequisitionsFilter = function(callback, fail){
            var options = {
                'ajaxtype': 'agencyGetAllRequisitionFilters',
                'url': jvAdminUsersUrls.getRequisitionsFilter,
            };
            prepareAjaxCall({}, options, function(response){
                var data = {};
                if(response){
                    data.statusFilter = [];
                    angular.forEach(response.statusFilter.optionValues,function(status){
                        data.statusFilter.push(status);
                        if(status.key===1 && status.mine === false){
                            data.defaultStatusFilterOption = JSON.stringify(status);
                        }
                    });
                    data.categoryFilter = response.filters.Categories;
                }
                callback(data);
            }, fail);
        };
    });